import React from 'react';
import { Button } from './ui/button';
import { Book, Heart, Sparkles } from 'lucide-react';

const EMERGENT_AUTH_URL = 'https://auth.emergentintegrations.ai';
const CLIENT_ID = '31e37c8e-e4be-4c9b-a78d-45decd4e2bfe';

const LoginPage = () => {
  const redirectUri = window.location.origin + '/';

  const handleGoogleLogin = () => {
    const authUrl = `${EMERGENT_AUTH_URL}/authorize?client_id=${CLIENT_ID}&redirect_uri=${encodeURIComponent(redirectUri)}&provider=google`;
    window.location.href = authUrl;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-purple-50 to-sky-50 flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-md" data-testid="login-page">
        {/* Logo */}
        <div className="text-center mb-8 fade-in">
          <div className="flex justify-center gap-4 mb-4">
            <Book className="w-6 h-6 text-purple-400 float-animation" />
            <Heart className="w-6 h-6 text-pink-400 float-animation" style={{ animationDelay: '0.5s' }} />
            <Sparkles className="w-6 h-6 text-amber-400 float-animation" style={{ animationDelay: '1s' }} />
          </div>
          <h1 className="text-4xl font-bold mb-2">
            <span className="bg-gradient-to-r from-pink-500 via-rose-400 to-purple-500 bg-clip-text text-transparent">Life Echo</span>
          </h1>
          <p className="text-gray-600 text-base">Your Story, Beautifully Told</p>
        </div>

        {/* Login Card */}
        <div className="glass-effect rounded-3xl p-8 shadow-xl fade-in" style={{ animationDelay: '0.2s' }}>
          <h2 className="text-xl font-bold text-gray-800 mb-2 text-center">Welcome</h2>
          <p className="text-gray-500 text-sm text-center mb-8">Sign in to create and manage your autobiographies</p>

          <Button
            onClick={handleGoogleLogin}
            className="w-full py-5 text-base font-medium rounded-full bg-white hover:bg-gray-50 text-gray-800 border border-gray-200 shadow-sm flex items-center justify-center gap-3"
            data-testid="google-login-btn"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
            </svg>
            Continue with Google
          </Button>

          <p className="text-xs text-center text-gray-400 mt-6">
            By signing in, you agree to our Terms of Service
          </p>
        </div>

        <p className="text-center text-sm text-gray-500 mt-6 fade-in" style={{ animationDelay: '0.4s' }}>
          <a href="/" className="text-purple-500 hover:text-purple-600 font-medium">Back to Home</a>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
